import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PasswordValidatorService {
  constructor() {}

  isValid(control: FormControl) {
    if (control.value && control.value.length > 7 && /\d/.test(control.value)) {
      return null;
    }
    return { invalidPassword: true };
  }
}
